// services/modules/categoryApi.js
import { api } from "../../api"; // importa la tua baseApi

export const categories = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllCategories: builder.query({
      query: () => ({
        url: "/categories/getall",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      // se vuoi normalizzare qui:
      transformResponse: (response) => response?.data?.result ?? [],
    }),

    getVideosByCategory: builder.query({
      query: ({ categoryId }) => ({
        url: "/user/networkandcategory",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ categoryId }).toString(),
      }),
      // normalizza per restituire solo array video:
      transformResponse: (response) => response?.data?.result?.videos ?? [],
    }),
    getVideosByNetworkAndCategory: builder.query({
      query: ({ categoryId }) => ({
        url: "/user/networkandcategory",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ categoryId }).toString(),
      }),
      // normalizza per restituire solo array video:
      transformResponse: (response) => response?.data?.result?.videos ?? [],
    })
  }),
  overrideExisting: false,
});

export const {
  useGetAllCategoriesQuery,
  useGetVideosByCategoryQuery,
  useGetVideosByNetworkAndCategoryQuery
} = categories;
